import { render, staticRenderFns } from "./barcode-control.vue?vue&type=template&id=ed8ae1c0&"
import script from "./barcode-control.ts?vue&type=script&lang=ts&"
export * from "./barcode-control.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports